// Deferred media (snippets/deferred-media.liquid): the player markup sits inert in a <template>
// and is only moved into the DOM when the shopper presses play, so a product video costs a poster
// image until someone actually wants to watch it.
//
// Delegated on the document rather than bound per element: the gallery is re-rendered on variant
// change and its slides are moved around by the slider, so a direct listener would be lost.

function loadDeferredMedia(container) {
  if (!container || container.hasAttribute("data-loaded")) return;

  const template = container.querySelector("template");
  const player = template?.content?.firstElementChild;
  if (!player) return;

  const node = player.cloneNode(true);
  container.setAttribute("data-loaded", "");
  container.appendChild(node);

  // Keep keyboard focus on the thing that replaced the button.
  if (!node.hasAttribute("tabindex")) node.setAttribute("tabindex", "0");
  try {
    node.focus({ preventScroll: true });
  } catch {
    // focus is a nicety; the player still loads
  }
}

if (!window.__deferredMediaBound) {
  window.__deferredMediaBound = true;

  document.addEventListener("click", (event) => {
    const trigger = event.target?.closest?.("[data-deferred-media-play]");
    if (!trigger) return;
    event.preventDefault();
    loadDeferredMedia(trigger.closest("[data-deferred-media]"));
  });
}

export { loadDeferredMedia };
